import React from 'react'
import { Modal } from './index'
import { SignUpForm } from '../Form/SignUpForm'
import { FacebookLoginButton } from '../Button/FacebookLoginButton'
import { GoogleLoginButton } from '../Button/GoogleLoginButton'
import { SocialLoginContainer } from './SocialLoginContainer'
import { ModalSeparator } from './ModalSeparator'
import { useAppDispatch } from '../../hooks/useAppDispatch'
import { showModal } from '../../states/modals/actions'
import { ModalType } from '../../states/modals/ModalType.constants'

type SignUpModalProps = {
  isAuthByCognito?: boolean
  isAuthByFacebook?: boolean
  isAuthByGoogle?: boolean
}

const SignUpModal: React.FunctionComponent<SignUpModalProps> = ({
  isAuthByCognito,
  isAuthByFacebook,
  isAuthByGoogle,
}) => {
  const dispatch = useAppDispatch()
  return (
    <Modal maxWidth={25} showLogo>
      {isAuthByCognito && (
        <SignUpForm
          isAuthByCognito={isAuthByCognito}
          isAuthByFacebook={isAuthByFacebook}
          isAuthByGoogle={isAuthByGoogle}
          onSuccess={(formFields) =>
            dispatch(
              showModal(ModalType.CONFIRM_EMAIL, {
                email: formFields.email,
              })
            )
          }
        />
      )}
      {isAuthByCognito && (isAuthByGoogle || isAuthByFacebook) && (
        <ModalSeparator />
      )}
      {(isAuthByGoogle || isAuthByFacebook) && (
        <SocialLoginContainer>
          {isAuthByFacebook && <FacebookLoginButton />}
          {isAuthByGoogle && <GoogleLoginButton />}
        </SocialLoginContainer>
      )}
    </Modal>
  )
}

export { SignUpModal }
